export const PER_PAGE_VALUES = [12, 24, 36, 48, 60, 72];

export const PAGESIZE_DEFAULT = 36;

export const SEARCH_COOKIE_NAMES = {
	userToken: "search_user_token",
	anonymousUserToken: "search_anonymous_user_token",
} as const;

export const SEARCH_KEYWORDS = {
	filter: `filter.`,
	sortBy: `sortBy`,
	page: "page",
	query: "query",
	pageSize: `pageSize`,
} as const;
